// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desktop-jumbo": "screen and (min-width: 1824px)",
	"desktop-large": "screen and (min-width: 1440px) and (max-width: 1823px)",
	"desktop-small": "screen and (min-width: 1280px) and (max-width: 1439px)",
	"phone": "screen and (min-width: 0) and (max-width: 480px)",
	"tablet-large": "screen and (min-width: 1024px) and (max-width: 1279px)",
	"tablet-medium": "screen and (min-width: 768px) and (max-width: 1023px)",
	"tablet-small": "screen and (min-width: 481px) and (max-width: 767px)"
};
export default ___CSS_LOADER_EXPORT___;
